@if (isLoading) {
  <div class="spinner-overlay">
    <p-progressSpinner class="custom-spinner"
      strokeWidth="4"
      animationDuration="1s"
      />
    </div>
  }